<template>
  <div v-if="debt" class="space-y-3">
    <div v-if="showResidentToggle || showScholarshipToggle" class="flex gap-2">
      <div v-if="showResidentToggle" class="inline-flex gap-1 border rounded-md p-0.5 font-medium text-sm whitespace-nowrap">
        <l-button
          :class="['py-0.5 px-2 rounded', { 'bg-orange-100 text-orange': resident }]"
          @click="() => setResident(true)"
        >
          Resident
        </l-button>
        <l-button
          :class="['py-0.5 px-2 rounded', { 'bg-orange-100 text-orange': !resident }]"
          @click="() => setResident(false)"
        >
          Non-resident
        </l-button>
      </div>
      <div v-if="showScholarshipToggle" class="inline-flex gap-1 border rounded-md p-0.5 font-medium text-sm whitespace-nowrap">
        <l-button
          :class="['py-0.5 px-2 rounded', { 'bg-orange-100 text-orange': scholarship }]"
          @click="() => setScholarship(true)"
        >
          With scholarship
        </l-button>
        <l-button
          :class="['py-0.5 px-2 rounded', { 'bg-orange-100 text-orange': !scholarship }]"
          @click="() => setScholarship(false)"
        >
          Without scholarship
        </l-button>
      </div>
    </div>

    <debt-projection :debt="debt" :finances="finances" :median-earnings="medianEarnings"/>
  </div>
</template>

<script setup>
import DebtProjection from "@/components/DebtProjection.vue"
import LButton from "@/components/buttons/LButton.vue"
import { computed, ref } from "vue"
const props = defineProps({
  debtProjections: { type: Object },
  finances: { type: Object },
  medianEarnings: { type: Number },
})

const showResidentToggle = computed(() => !!props.debtProjections.debt_resident)
const showScholarshipToggle = computed(() => !!props.debtProjections.debt_discounted)
const resident = ref(showResidentToggle.value)
const scholarship = ref(showScholarshipToggle.value)

const setResident = (value) => resident.value = value
const setScholarship = (value) => scholarship.value = value

const debt = computed(() => {
  if (resident.value && scholarship.value) {
    return props.debtProjections.debt_resident_discounted || props.debtProjections.debt
  }

  if (!resident.value && scholarship.value) {
    return props.debtProjections.debt_discounted || props.debtProjections.debt
  }

  if (resident.value && !scholarship.value) {
    return props.debtProjections.debt_resident || props.debtProjections.debt
  }

  return props.debtProjections.debt
})
</script>
